<template>
  <div>
    <div class="py-10 text-center f-20">关联基础产品</div>
    <div class="p-t-10 p-l-10 p-r-10" v-if='list.length'>
        <div
          class="s_flex_bian_c p-t-10 p-b-10 s_bf p-l-15 p-r-15"
          v-for="(item, index) in list"
          :key="index"
        >
          <imgCard
            class="width-80 height-80 tw-rounded-sm"
            :url="item.product_image"
          ></imgCard>
          <div class="width72">
            <p class="fz-15 s_omit2">{{ item.product_name }}</p>
            <p class="tw-text-gray-400 m-t-5" v-if="item.product_type==0">
              规格：{{ item.product_sku_name || "单规格" }}
            </p>
              <div  class="height-25 s_flex_center s_bf054 width-55 tw-text-white tw-rounded-sm" v-if="item.product_type==1">
                组合装
              </div>
            <p class="tw-text-gray-400">商品编号：{{ item.product_sn }}</p>
            <p class="tw-text-gray-400" v-if="item.product_sku_name">规格编号：{{ item.product_sku_sn||'-' }}</p>
          </div>
        </div>

    </div>
  </div>
</template>

<script>
	export default {
		name: "showGoodsList",
		props: {
			list: {
				type: Array
			}
		},
		setup(props, {
			emit
		}) {

			return {

			};
		}
	};
</script>

<style scoped>
	.m_text {
		width: 300px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
	}
</style>
